import * as React from 'react'
import cx from 'classnames'
import * as Yup from 'yup'
import { TextInput } from '@toasttab/buffet-pui-text-input'
import { Select } from '@toasttab/buffet-pui-select'
import { Field } from './fields'
import { HandleSetFieldValues } from '.'

/**
 * InputFieldProps
 * Used internally to manage the inputs needed for an international address
 */
interface InputFieldProps
  extends Pick<
    Field,
    'name' | 'label' | 'type' | 'options' | 'containerClassName' | 'className'
  > {
  value: string
  handleSetFieldValues: HandleSetFieldValues
  validation?: Yup.StringSchema
  testId: string
  validateField: boolean
}

export const InputField: React.FC<InputFieldProps> = ({
  name,
  label,
  type,
  options,
  containerClassName,
  className,
  value,
  handleSetFieldValues,
  validation,
  testId,
  validateField
}) => {
  const [isDirty, setIsDirty] = React.useState(validateField)
  const defaultClassNames = 'mt-4 fade-in'

  const handleValidation = (value: string) => {
    try {
      if (validation) {
        validation.validateSync(value)
      }
    } catch (err) {
      let message = 'Unknown Error'
      if (err instanceof Error) message = err.message
      return message
    }
  }

  switch (type) {
    case 'select':
      return (
        <div className={cx(defaultClassNames, containerClassName)}>
          <Select
            containerClassName={className}
            name={name}
            label={label}
            options={options || []}
            value={value}
            onChange={(value) => {
              setIsDirty(true)
              handleSetFieldValues(name, `${value}`)
            }}
            onClose={() => setIsDirty(true)}
            autoComplete={name}
            invalid={(isDirty || validateField) && !!handleValidation(value)}
            errorText={
              isDirty || validateField ? handleValidation(value) : undefined
            }
            testId={`${testId}-select`}
          />
        </div>
      )
    default:
      // text
      return (
        <div className={cx(defaultClassNames, containerClassName)}>
          <TextInput
            containerClassName={className}
            name={name}
            label={label}
            value={value}
            onChange={(e) => {
              setIsDirty(true)
              handleSetFieldValues(name, e.target.value)
            }}
            onBlur={() => setIsDirty(true)}
            invalid={(isDirty || validateField) && !!handleValidation(value)}
            errorText={
              isDirty || validateField ? handleValidation(value) : undefined
            }
            testId={`${testId}-input`}
          />
        </div>
      )
  }
}
